































import { Component, PropSync, Vue } from 'vue-property-decorator';
import { HistorySection } from '@/lib/domain/history-section';

@Component
export default class Section extends Vue {
  public activeTab = 0;
  @PropSync('current') currentSection!: HistorySection;

  isActiveTab(index: number): boolean {
    return this.activeTab == index;
  }

  getSectionPicture(id = 'hero'): string {
    return `img/${this.currentSection.Id}/${id}.jpg`;
  }
}
